export default __webpack_public_path__ + "static/media/Group 8145.b35194ef.png";